export default [
  {
    path: '/management_reports',
    name: 'management-reports',
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      title: 'Management Reports - Innovation Law Lab Platform',
    },
    component: _ => import('@/views/ManagementReports'),
  },
]
